import React, { useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

const AddSecret = () => {
  const [formData, setFormData] = useState({
    key: "",
    value: "",
    description: ""
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.key.trim()) {
      newErrors.key = "Key is required";
    }

    if (!formData.value.trim()) {
      newErrors.value = "Value is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const res = await axiosInstance.post("/config/createSecret", formData);
        if (res) {
          navigate("/secrets");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "An error occurred.");
      }
    }
  };

  return (
    <div className="">
      <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-lg">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Add Secret</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="key" className="block text-sm font-semibold text-gray-700">
              Key
            </label>
            <input
              type="text"
              id="key"
              name="key"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter Key"
              onChange={handleChange}
              value={formData.key}
            />
            {errors.key && (
              <p className="text-red-600 text-sm mt-1">{errors.key}</p>
            )}
          </div>

          <div className="mb-4">
            <label htmlFor="value" className="block text-sm font-semibold text-gray-700">
              Value
            </label>
            <input
              type="text"
              id="value"
              name="value"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter Value"
              onChange={handleChange}
              value={formData.value}
            />
            {errors.value && (
              <p className="text-red-600 text-sm mt-1">{errors.value}</p>
            )}
          </div>

          <div className="mb-4">
            <label htmlFor="description" className="block text-sm font-semibold text-gray-700">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              rows="4"
              placeholder="Enter Description"
              onChange={handleChange}
              value={formData.description}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="bg-blue-600 text-white font-medium px-6 py-2 rounded-md shadow hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSecret;
